<template>
  <prismic-rich-text
    class="text-center text-white title"
    :field="title"
    style="min-height: 4em"
  ></prismic-rich-text>
</template>
<script>
export default {
  props: {
    title: {
      type: Array,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  @include min-md {
    max-width: 50%;
  }
  ::v-deep > * {
    margin: 0;
    font-size: 1.4rem;
    @include min-lg {
      font-size: 2rem;
    }
  }
}
</style>
